import { makeObservable, observable, runInAction } from "mobx";
import moment from "moment";
import { webAPI } from "../api/Api";
import reportsAPI from "../api/Reports";

class SitPanelReportsStore {
  format = "HH:mm";

  timeFrom = moment("08:00", this.format);
  timeTo = moment("08:00", this.format);
  dateFrom = moment().subtract(1, "days").startOf("day");
  dateTo = moment();

  reportStatus = "";

  constructor() {
    makeObservable(
      this,
      {
        timeTo: observable,
        timeFrom: observable,
        dateTo: observable,
        dateFrom: observable,
        reportStatus: observable,
      },
      {
        deep: true,
      },
    );
  }

  async downloadAnalyticalReport(filter: IAnalyticaFilter) {
    return this.downloadReport(
      filter,
      "/sp/Analytics/GenerateAnalyticalReport",
      "Аналитическая справка",
    );
  }

  async downloadDailyViolationsReport(filter: IAnalyticaFilter) {
    return this.downloadReport(
      filter,
      "/sp/Analytics/GenerateDailyViolationsReport",
      "Суточная сводка по нарушениям",
    );
  }

  async downloadReport(
    filter: IAnalyticaFilter,
    endPoint: string,
    name?: string,
  ) {
    try {
      const options = { responseType: "blob", params: filter };
      const res = await webAPI.get(endPoint, options).then((response) => {
        const blob = new Blob([response.data], { type: response.data.type });
        const link = document.createElement("a");
        const contentDisposition = response.headers["content-disposition"];
        let filename = "defects";
        if (contentDisposition) {
          const matches = contentDisposition.match(/filename=([\w\d\-_.]+)/);
          if (matches && matches.length === 2) {
            filename = matches[1];
          }
        }
        const [, end] = filename.split(".");
        link.href = URL.createObjectURL(blob);
        link.download = name ? `${name}.${end || "docx"}` : filename;
        link.click();
        URL.revokeObjectURL(link.href);
        this.setActionResult("Запись успешно добавлена");
      });
    } catch (e) {
      this.setActionResult(`Ошибка ${e}`);
    }
  }

  async downloadDoneReport(fileId: string, name?: string) {
    try {
      const options = { responseType: "blob" };
      const response = await webAPI.get(
        `/sp/Reports/DownloadReport?id=${fileId}`,
        options,
      );
      const blob = new Blob([response.data], { type: response.data.type });
      const link = document.createElement("a");

      const token =
        response.headers["content-disposition"].split("filename=")[1];
      const filename = decodeURIComponent(
        token ? token.split(";")[1] : token,
      ).substring(18);

      link.href = URL.createObjectURL(blob);
      const [, end] = filename.split(".");
      link.download = name ? `${name}.${end}` : filename;
      link.click();
      URL.revokeObjectURL(link.href);
    } catch (e) {
      this.setActionResult(`Ошибка ${e}`);
    }
  }

  async uploadReportFile(reportId, formData) {
    try {
      await reportsAPI.uploadReportFile(reportId, formData);

      this.setActionResult("Запись успешно обновлена");
    } catch (e) {
      this.setActionResult("Произошла ошибка");
      console.log(e);
    }
  }

  setActionResult(value) {
    runInAction(() => {
      this.reportStatus = value;
    });
  }

  setTimeFrom(value) {
    runInAction(() => {
      this.timeFrom = value;
    });
  }

  setTimeTo(value) {
    runInAction(() => {
      this.timeTo = value;
    });
  }

  toIsoDate = (date, time) => {
    const timePart = time.format(this.format);
    const datePart = date.format("YYYY-MM-DD");
    const fullTime = `${datePart}T${timePart}:00.000`;
    return fullTime;
  };

  deleteReport = async (id) => {
    try {
      await reportsAPI.deleteReport({ id });
      this.setActionResult("Запись успешно удалена");
    } catch (e) {
      this.setActionResult("Произошла ошибка");
      console.log(e);
    }
  };
}

const sitPanelReports = new SitPanelReportsStore();
export default sitPanelReports;
